import BaseApi from './BaseApi'

export default class JourneyApi extends BaseApi {
    async getJourneys (startDate, endDate, vehicleId, returnLastJourney) {
        return await this.get(`/api/v1.0/journeys`, {
            StartDate: startDate,
            EndDate: endDate,
            VehicleId: vehicleId,
            ReturnLastJourney: returnLastJourney
        })
    }
    async getJourney (journeyId, isLastJourney = false) {
        return await this.get(`/api/v1.0/journeys/${journeyId}/${isLastJourney}`)
    }
    async getJourneyTimeline (startDate, endDate, vehicleId) {
        return await this.get(`/api/v1.0/journeys/timeline`, {
            StartDate: startDate,
            EndDate: endDate,
            VehicleId: vehicleId
        })
    }
    async reprocessJourneys (fromDate, toDate, vehicleId) {
        return this.post(`/api/v1.0/journeys/reprocess`, {
            fromDate,
            toDate,
            vehicleId
        })
    }
}
